<template>
  <div class="border rounded p-2">
    <h4 class="mb-1">
      {{ label }}
    </h4>
    <b-media
      no-body
      vertical-align="center"
      class="flex-column flex-md-row"
    >
      <b-media-aside>
        <video
          v-if="type === 'video' && src"
          ref="refVideo"
          width="170"
          controls
        >
          <source :src="src">
          Your browser does not support HTML5 video.
        </video>
        <b-img
          v-else-if="type === 'image'"
          :src="src"
          height="110"
          width="170"
          class="rounded mr-2 mb-1 mb-md-0"
        />
        <b-img
          v-else
          :src="src"
          height="110"
          width="170"
          class="rounded mr-2 mb-1 mb-md-0"
        />
      </b-media-aside>
      <b-media-body>
        <div class="d-inline-block">
          <b-form-file
            :id="id"
            v-model="selfValue"
            :accept="onlyAccept"
            :placeholder="placeholder"
            @change="handleInput($event)"
          />
          <slot name="invalidFeedback" />
        </div>
      </b-media-body>
    </b-media>
  </div>
</template>

<script>
import {
  BMedia, BMediaAside, BMediaBody, BImg, BFormFile,
} from 'bootstrap-vue'
import '@/components/BFormInvalid/index.vue'
import { ref } from '@vue/composition-api'

export default {
  name: 'BFileAttachInput',
  components: {
    BMedia,
    BMediaAside,
    BMediaBody,
    BImg,
    BFormFile,
  },
  props: {
    value: {
      type: [Object, File],
    },
    id: {
      type: [String, Number],
    },
    placeholder: {
      type: [String],
      default: 'انتخاب کنید',
    },
    label: {
      type: String,
      default: '',
    },
    accept: {
      type: String,
    },
    type: {
      type: String,
      default: 'image',
    },
  },
  setup() {
    const refVideo = ref(null)
    return {
      refVideo,
    }
  },
  data() {
    return {
      selfValue: null,
      imageObj: null,
      src: null,
      selfAlt: null,
    }
  },
  computed: {
    onlyAccept() {
      if (this.accept) return this.accept
      if (this.type === 'image') return '.jpg, .jpeg, .png'
      return ''
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val && val._id) {
          this.src = this.createFullFileAddress(val)
        }
      },
      immediate: true,
    },
    selfValue(val) {
      this.$emit('input', val)
    },
  },
  methods: {
    uploadClientImage($event) {
      const [image] = $event.currentTarget.files
      this.imageObj = image
      this.src = URL.createObjectURL($event.currentTarget.files[0])
      if (this.type === 'video' && this.refVideo) {
        this.refVideo.load()
      }
    },
    handleInput($event) {
      this.uploadClientImage($event)
    },
    createFullFileAddress({
      baseUrl,
      bucketName,
      destination,
      filename,
    }) {
      return `${baseUrl + bucketName}/${destination}${filename}`
    },
  },
}
</script>
